import { Component, OnInit } from '@angular/core';
import * as CommonConstants from 'src/app/utils/common.constants';
import { DynamicFormService } from '../dynamic-form-builder/dynamic-form-service';
import { PatientService } from '../patients/patient.service';

@Component({
  selector: 'app-myspace-dashboard',
  templateUrl: './myspace-dashboard.component.html',
  styleUrls: ['./myspace-dashboard.component.scss']
})
export class MyspaceDashboardComponent implements OnInit {
  partnerId=+localStorage.getItem(CommonConstants.PARTNER_ID);
  partnerType=+localStorage.getItem(CommonConstants.PARTNER_TYPE);
  createdUser=localStorage.getItem(CommonConstants.EMPLOYEE_NAME);
  patientList: any;
  medicalFiles: any;
  mySpaceCount: any;
  constructor(private dynamicForm:DynamicFormService,private patientService:PatientService) { }

  expandContent = true;
  data1 = [{
    'name': 'John',
    'id': '524859',
    'country': 'France',
    'place': 'Paris',
    'expanded': false
  }, {
    'name': 'Jane',
    'id': '524859',
    'country': 'France',
    'place': 'Lyon',
    'expanded': false
  }, {
    'name': 'Mary',
    'id': 'France',
    'phone': 'Cannes',
    'expanded': false
  },
  ]

  data2 = [{
    'whoseData': 'John',
    'datades': {
      'name': 'John',
      'hobbies': 'singing',
      'profession': 'singer'
    }
  }, {
    'whoseData': 'Jane',
    'datades': {
      'name': 'Jane',
      'hobbies': 'coding',
      'profession': 'coder'
    }
  }, {
    'whoseData': 'Mary',
    'datades': {
      'name': 'Mary',
      'hobbies': 'testing',
      'profession': 'tester'
    }
  }
  ]

  ngOnInit() {
    let obj={};
    obj["createdUser"]=this.createdUser;
    this.patientService.getPatients(obj).subscribe(response => {
      if (response && response['result']) {
        this.patientList = response['result'];
      }
    })
    this.dynamicForm.getMedicalFile(this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.medicalFiles = response['result'];
      }
    })
    this.dynamicForm.getCount(this.partnerId,this.partnerType).subscribe(response => {
      if (response && response['result']) {
        this.mySpaceCount = response['result'];
      }
    })
  }


  findDetails(data) {
    return this.data2.filter(x => x.whoseData === data.name);
  }

 

}
